import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: 'dashboard', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/applications',
    component: Layout,
    children: [
      {
        path: 'applications',
        component: () => import('@/views/applications/index'),
        name: 'Applications',
        meta: { title: 'applications', icon: 'el-icon-menu' }
      }
    ]
  },
  {
    path: '/billing',
    component: Layout,
    children: [
      {
        path: 'billing',
        component: () => import('@/views/billing/index'),
        name: 'Billing',
        meta: { title: 'billing', icon: 'el-icon-bank-card' }
      }
    ]
  },
  {
    path: '/log',
    component: Layout,
    name: 'Log',
    meta: {
      title: 'log',
      icon: 'el-icon-document-copy'
    },
    children: [
      {
        path: 'aiCallRecord',
        component: () => import('@/views/ai-call-record/index'),
        name: 'AiCallRecord',
        meta: { title: 'aiCallRecord', icon: 'el-icon-connection' }
      },
      {
        path: 'creditLog',
        component: () => import('@/views/credit-log/index'),
        name: 'CreditLog',
        meta: { title: 'creditLog', icon: 'el-icon-coin' }
      }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    name: 'Statistics',
    meta: {
      title: 'statistics',
      icon: 'el-icon-s-data'
    },
    alwaysShow: true,
    children: [
      {
        path: 'statAiCallRecord',
        component: () => import('@/views/statistics/stat-ai-call-record'),
        name: 'StatAiCallRecord',
        meta: { title: 'aiCallRecord', icon: 'el-icon-connection' }
      }
    ]
  },
  {
    path: '/ticket',
    component: Layout,
    children: [
      {
        path: 'ticket',
        component: () => import('@/views/ticket/index'),
        name: 'Ticket',
        meta: { title: 'ticket', icon: 'el-icon-s-order' }
      },
      {
        path: 'detail/:ticket_no',
        component: () => import('@/views/ticket/detail'),
        hidden: true,
        name: 'TicketDetail',
        meta: { title: 'ticketDetail' }
      }
    ]
  },
  {
    path: '/team',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'team',
        component: () => import('@/views/team/index'),
        name: 'Team',
        meta: { title: 'team' }
      },
      {
        path: 'team-member',
        component: () => import('@/views/team-member/index'),
        name: 'TeamMember',
        meta: { title: 'teamMember' }
      }
    ]
  },

  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
